import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { ReduxControls } from "rhombus-react";

import VariablesSelector from './VariablesSelector';
import { maxLength, requiredNotNull } from 'widgets/forms/validators/validators';
import { validVersionNameCharacters } from "forms/validators/Versions";
import { noop } from 'utils/common';
import { useDispatch, useSelector } from 'react-redux';
import { getMetadataEntriesByType } from 'reducers/VersionGeneration';

const MAX_LENGTH_PREFIX = 100;
const maxLengthPrefix = maxLength(MAX_LENGTH_PREFIX);

const MAX_LENGTH_PROMPT = 500;
const maxLengthPrompt = maxLength(MAX_LENGTH_PROMPT);

const METADATA_BRANDS_NAME = "brand-kits";
const METADATA_AUDIENCES_NAME = "audiences";
const METADATA_PRODUCTS_NAME = "products";

export default function PromptPanel(props){
	const { libraryId, isDisabled, anyTouched } = props;
	const dispatch = useDispatch();
	const metadata = useSelector(state => state.versionGeneration.metadata);

	const brandKits = metadata["brand-kits"] || [];
	const { audiences = [], products = []} = metadata;

	const normalizeMetadataValues = value => value?.value;

	useEffect(() => {
		dispatch(getMetadataEntriesByType(libraryId, METADATA_BRANDS_NAME));
		dispatch(getMetadataEntriesByType(libraryId, METADATA_AUDIENCES_NAME));
		dispatch(getMetadataEntriesByType(libraryId, METADATA_PRODUCTS_NAME));
	}, [libraryId]);

	return (
		<div className="prompt-panel">
			<div className="panel-title">
				Prompt
			</div>
			<div className="panel-body">
				<Field
					name="prompt"
					label="Describe Versions to Generate"
					className="cypress-gen-ai-prompt-field"
					component={ReduxControls.Input}
					type="textarea"
					placeholder="Enter a description for the versions you want to generate…"
					validate={[requiredNotNull, maxLengthPrompt]}
					disabled={isDisabled}
					showCharCount
					charMax={MAX_LENGTH_PROMPT}
				/>
				<hr />
				<Field
					name={METADATA_AUDIENCES_NAME}
					label="Audience"
					className="cypress-gen-ai-version-audience-field"
					component={ReduxControls.Select}
					options={audiences}
					disabled={isDisabled}
					normalize={normalizeMetadataValues}
					onMenuScrollToBottom={noop}
				/>
				<Field
					name={METADATA_BRANDS_NAME}
					label="Brand Kit"
					className="cypress-gen-ai-version-brands-field"
					component={ReduxControls.Select}
					options={brandKits}
					disabled={isDisabled}
					normalize={normalizeMetadataValues}
					onMenuScrollToBottom={noop}
				/>
				<Field
					name={METADATA_PRODUCTS_NAME}
					label="Product"
					className="cypress-gen-ai-version-product-field"
					options={products}
					component={ReduxControls.Select}
					disabled={isDisabled}
					normalize={normalizeMetadataValues}
					onMenuScrollToBottom={noop}
				/>
				<hr />
				<Field
					name="versionNamePrefix"
					label="Version Prefix Name"
					className="cypress-gen-ai-version-prefix-field"
					component={ReduxControls.Input}
					required
					validate={[requiredNotNull, maxLengthPrefix, validVersionNameCharacters]}
					disabled={isDisabled}
					showCharCount
					charMax={MAX_LENGTH_PREFIX}
				/>
				<hr />
				<VariablesSelector anyTouched={anyTouched} />
			</div>
		</div>
	);
}

PromptPanel.displayName = "PromptPanel";
